export default __webpack_public_path__ + "static/media/logo.08e867f8.png";